
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 16.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.063.753a.933.933 0 00-.72.332.933.933 0 00.114 1.317l13.422 11.29a.933.933 0 001.314-.112.933.933 0 00-.113-1.317l-.687-.578a9.672 9.672 0 002.584-3.682c-1.412-3.58-4.895-6.117-8.973-6.117a9.537 9.537 0 00-4.135.946L2.66.972a.933.933 0 00-.598-.219zm6.94 2.766a7.966 7.966 0 017.194 4.484 7.938 7.938 0 01-2.064 2.622l-1.684-1.416c.135-.38.225-.78.225-1.206a3.675 3.675 0 00-3.67-3.67c-.65 0-1.26.172-1.79.471l-.94-.79a7.957 7.957 0 012.73-.495zM1.886 5.037A9.667 9.667 0 00.03 8.003c1.411 3.581 4.895 6.12 8.973 6.12a9.6 9.6 0 003.076-.508l-1.533-1.291a8.089 8.089 0 01-1.543.166A7.96 7.96 0 011.81 8.003a7.96 7.96 0 011.318-1.92L1.885 5.038zm7.119.927a2.039 2.039 0 012.039 2.04l-.002.019L8.637 6c.12-.023.243-.036.367-.036zM5.34 7.944c0 .02-.006.04-.006.06a3.677 3.677 0 003.67 3.671c.235 0 .464-.027.687-.07L5.34 7.945z"}})])
          )
        }
      }
    